import { Dispatch, ReactNode, useEffect } from 'react'

export const ComboboxItems = ({
  setIsOpen,
  open = false,
  children,
  className = '',
}: {
  setIsOpen: Dispatch<boolean>
  open: boolean
  children: ReactNode
  className?: string
}) => {
  useEffect(() => {
    setIsOpen(open)
  }, [open])

  return <div className={className}>{children}</div>
}
